export { default } from "./GlobalFooter";
